import { render, staticRenderFns } from "./tag-dialog.vue?vue&type=template&id=273cd506&scoped=true&"
import script from "./tag-dialog.vue?vue&type=script&lang=js&"
export * from "./tag-dialog.vue?vue&type=script&lang=js&"
import style0 from "./tag-dialog.vue?vue&type=style&index=0&id=273cd506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273cd506",
  null
  
)

export default component.exports